(function() {
	'use strict';
	angular.module('app.leanProjects')
		.service('projectRenderService', projectRenderService);

	projectRenderService.$inject = ['$filter', '$timeout', 'siteUrl', 'currencyFormatService', 'leanTableService', 'integerFormatService', 'leanFilterService', 'percentageFormatService', 'numberFormatService'];

	function projectRenderService($filter, $timeout, siteUrl, currencyFormatService,   leanTableService, integerFormatService, leanFilterService, percentageFormatService, numberFormatService) {
		var colorMap = {
			'30-bad': 'bad',
			'20-warn': 'warn',
			'10-good': 'good',
			'complete': 'complete'
		};
		var titleMap = {
			'30-bad': 'Not on plan, and there are issues',
			'10-good': 'On plan',
			'20-warn': 'Not on plan, but we can recover'
		};

		var service = {
			getActionElement: getActionElement,
			getColor: getColor,
			getHyperLink: getHyperLink,
			getStageColor: getStageColor,
			getStageTitle: getStageTitle,
			hasApprove: hasApprove,
			hasArchive: hasArchive,
			hasDelete: hasDelete,
			overdueDate: overdueDate
		};

		return service;

		function overdueDate(dueDate, completeFlag, stageSequence, factoryNdx, stagesListMap) {
			if (completeFlag) {
				return false;
			}
			var stageIndex = -1;
			for (var i = 0; i < stagesListMap[factoryNdx].length; i++) {
				if (stagesListMap[factoryNdx][i].stageSequence == stageSequence) {
					stageIndex = i;
				}
			}
			if (stageIndex == stagesListMap[factoryNdx].length - 1) {
				return false;
			} else if (stagesListMap[factoryNdx].length >= 2 && stageIndex == stagesListMap[factoryNdx].length - 2) {
				return false;
			}
			return moment().isAfter(dueDate, 'day');
		}
		
		function getStageColor(currentSequence, stageSequence, currentStatus) {
			var classColor = 'blankState';
			if (stageSequence < currentSequence) {
				classColor = 'complete';
			} else if (stageSequence == currentSequence) {
				classColor = colorMap[currentStatus];
			}
			return classColor;
		}

		function getStageTitle(currentSequence, stageSequence, stageName, currentStatus) {
			var result = stageName + ': ';
			if (currentSequence > stageSequence) {
				result += 'Complete';
			} else if (currentSequence == stageSequence) {
				result += titleMap[currentStatus];
			} else {
				result = '';
			}
			return result;
		}

		function hasApprove(stage, projectManagerNdx, adminNdx, userIsApprover, factoryNdx) {
			if (!factoryNdx) factoryNdx = globalConfig.factory.id;
			return stage === 'Pending Approval' && (
				globalConfig.user.authFacts[factoryNdx].profileType === 'SystemAdministrator' ||
				globalConfig.user.authFacts[factoryNdx].profileType === 'SuperSystemAdministrator' ||
				globalConfig.user.authFacts[factoryNdx].initAuthz ||
				userIsApprover === 1);
		}

		function hasArchive(stage, projectManagerNdx, adminNdx, projectSponsorNdxs, creatorNdx, userIsApprover, factoryNdx) {
			if (!factoryNdx) factoryNdx = globalConfig.factory.id;
			if (stage === 'Archive') {
				return false;
			}
			if (globalConfig.user.authFacts[factoryNdx].profileType === 'SystemAdministrator' ||
				globalConfig.user.authFacts[factoryNdx].profileType === 'SuperSystemAdministrator' ||
				globalConfig.user.authFacts[factoryNdx].initAuthz ||
				userIsApprover === 1) {
				return true;
			}
			var adminNdxList = [];
			if (adminNdx && adminNdx.length) {
				adminNdxList = adminNdx.split(',');
			}
			var projectSponsorNdxList = [];
			if (projectSponsorNdxs && projectSponsorNdxs.length) {
				projectSponsorNdxList = projectSponsorNdxs.split(',');
			}
			if (stage == 'Pending Approval') {
				return globalConfig.user.id == creatorNdx;
			}
			return globalConfig.user.id == projectManagerNdx ||
				adminNdxList.indexOf('' + globalConfig.user.id) >= 0 ||
				projectSponsorNdxList.indexOf('' + globalConfig.user.id) >= 0;
		}

		function hasDelete(stage, projectManagerNdx, adminNdx, projectSponsorNdxs, userIsApprover, factoryNdx) {
			var adminNdxList = [];
			if (adminNdx && adminNdx.length) {
				adminNdxList = adminNdx.split(',');
			}
			var projectSponsorNdxList = [];
			if (projectSponsorNdxs && projectSponsorNdxs.length) {
				projectSponsorNdxList = projectSponsorNdxs.split(',');
			}
			return stage === 'Archive' && (
				globalConfig.user.authFacts[factoryNdx].profileType === 'SystemAdministrator' ||
				globalConfig.user.authFacts[factoryNdx].profileType === 'SuperSystemAdministrator' ||
				globalConfig.user.authFacts[factoryNdx].initAuthz ||
				globalConfig.user.id == projectManagerNdx ||
				userIsApprover === 1 ||
				adminNdxList.indexOf('' + globalConfig.user.id) >= 0 ||
				projectSponsorNdxList.indexOf('' + globalConfig.user.id) >= 0);
		}

		function getActionElement(actionType, row) {
			var actionElement = '';
			switch(actionType) {
			case 'Approve':
				actionElement = '<i class="fa fa-check" '
						+ 'title="Click to approve project" ng-click="vm.approveProject(\'' + row.projNdx + '\', ' + row.lastModified + ', ' + row.leanDirFactoryNdx +')"></i>';
				break;
			case 'Archive':
				actionElement = '<i class="fa fa-archive" '
						+ 'title="Click to archive project" ng-click="vm.archiveProject(\'' + row.projNdx + '\',  ' + row.lastModified + ', ' + row.leanDirFactoryNdx + ')"></i>';
				break;
			case 'Delete':
				actionElement = '<i class="fa fa-trash" '
						+ 'title="Click to delete project" ng-click="vm.deleteProject(\'' + row.projNdx + '\',  \'' + row.lastModified + '\', \'' + row.leanDirFactoryNdx + '\')"></i>';
				break;
			}
			return actionElement;
		}

		function getHyperLink(projNdx, factoryNdx, viewLink) {
			var link = viewLink + projNdx;
			if (factoryNdx) {
				link += '&factoryNdx=' + factoryNdx;
			}
			return link;
		}

		function getColor(status, completeFlag, stageSequence) {
			status = completeFlag && stageSequence != 1000 ? 'complete' : status;
			return colorMap[status];
		}
	}
})();
